<div *ngIf="this.loader.getLoadingStatus" class="cssload-container">
  <img class='spinner-position' src='/img/loader_transparent.gif' alt=''>
</div>
